import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button } from "@mui/material";

interface Props {
  onReply: () => void;
}

export const ReplyButton: React.FC<Props> = ({ onReply }) => {
  return (
    <Box sx={{ pl: "50px" }}>
      <Button
        startIcon={<ArrowBackIcon sx={{ fontSize: "16px", color: "#071f35" }} />}
        onClick={onReply}
        sx={{
          fontSize: "12px",
          fontWeight: 400,
          color: "#071f35",
          textTransform: "none",
          minWidth: "auto",
          px: "8px",
          py: "4px",
          borderRadius: "32px",
          maxWidth: "240px",
          gap: "4px"
        }}
      >
        Reply
      </Button>
    </Box>
  );
};

